import { Check } from "lucide-react";

// Options cochables de la génération / retouche de logo. La liste vient du
// serveur (registre fermé services/ai/logo_options.py) : l'interface
// n'envoie que des clés, jamais de texte de consigne.

/** Coche ou décoche une option ; cocher retire les options incompatibles. */
export function toggleOption(value, key, options) {
  const current = Array.isArray(value) ? value : [];
  if (current.includes(key)) return current.filter((k) => k !== key);
  const option = (options || []).find((o) => o.key === key);
  const excluded = new Set(option?.excludes || []);
  // Les exclusions sont déclarées dans les deux sens, mais une liste
  // incomplète ne doit pas laisser deux options incompatibles cochées.
  (options || []).forEach((o) => { if ((o.excludes || []).includes(key)) excluded.add(o.key); });
  return [...current.filter((k) => !excluded.has(k)), key];
}

export default function AILogoOptions({ options, value, onChange, title = "Options du logo", compact = false, testid = "ai-logo-options" }) {
  if (!options?.length) return null;
  const selected = Array.isArray(value) ? value : [];
  return (
    <fieldset data-testid={testid}>
      <legend className="text-[11px] uppercase tracking-[0.15em] text-ash">{title}</legend>
      <div className={`mt-1.5 grid gap-1.5 ${compact ? "sm:grid-cols-2" : "sm:grid-cols-2"}`}>
        {options.map((o) => {
          const checked = selected.includes(o.key);
          return (
            <label
              key={o.key}
              className={`flex items-start gap-2.5 rounded-sm border p-2.5 cursor-pointer transition-colors ${
                checked ? "border-copper bg-sand" : "border-stone bg-white hover:border-copper/50"
              }`}
            >
              <input
                type="checkbox"
                className="sr-only peer"
                data-testid={`${testid}-${o.key}`}
                checked={checked}
                onChange={() => onChange(toggleOption(selected, o.key, options))}
              />
              <span
                aria-hidden="true"
                className={`mt-0.5 h-4 w-4 shrink-0 rounded-[3px] border flex items-center justify-center peer-focus-visible:ring-2 peer-focus-visible:ring-copper ${
                  checked ? "bg-copper border-copper text-white" : "border-ash bg-white"
                }`}
              >
                {checked && <Check className="h-3 w-3" strokeWidth={3} />}
              </span>
              <span className="min-w-0">
                <span className="block text-[13px] text-ink leading-snug">{o.label}</span>
                {!compact && o.help && <span className="block text-[11px] text-ash leading-snug mt-0.5">{o.help}</span>}
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
